import {
  systemInformationsInitialValue,
} from '@/types/auth/systemInformations';

export default {
  systemInformations: systemInformationsInitialValue,
  userPermissions: [],
  userRoles: [],
};
